import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import reportWebVitals from "./hooks/reportWebVitals";
const root = ReactDOM.createRoot(document.getElementById("root"));
import "./i18n";

root.render(
  <>
    <App />
  </>,
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
